export const SWIPE_ACTION_WIDTH = 82;
export const SWIPE_START_THRESHOLD = 8;
export const SWIPE_AXIS_BIAS = 1.15;

export function swipeAxis(deltaX, deltaY) {
  const horizontal = Math.abs(deltaX);
  const vertical = Math.abs(deltaY);
  if (Math.max(horizontal, vertical) < SWIPE_START_THRESHOLD) return null;
  if (horizontal > vertical * SWIPE_AXIS_BIAS) return "horizontal";
  if (vertical > horizontal * SWIPE_AXIS_BIAS) return "vertical";
  return null;
}

export function clampSwipeOffset(offset) {
  return Math.max(-SWIPE_ACTION_WIDTH, Math.min(0, offset));
}

export function shouldOpenSwipe(offset, cancelled = false, wasOpen = false) {
  if (cancelled) return wasOpen;
  return offset <= -SWIPE_ACTION_WIDTH / 2;
}
